/// Formatage des dates d'historique.
///
/// PocketBase renvoie ses dates au format `YYYY-MM-DD HH:MM:SS.mmmZ` : l'espace entre la date et
/// l'heure n'est pas de l'ISO 8601 valide et Safari refuse de le parser. On le normalise avant de
/// construire la `Date`.
function parsePocketBaseDate(value: string): Date | null {
  if (!value) return null;

  const date = new Date(value.replace(" ", "T"));
  return Number.isNaN(date.getTime()) ? null : date;
}

/// Date et heure lisibles, ex. « 12 juin 2026, 14:22 ».
///
/// Retourne la valeur brute si elle est illisible, plutôt qu'un « Invalid Date ».
export function formatHistoryDate(value: string, language: string): string {
  const date = parsePocketBaseDate(value);
  if (!date) return value;

  return new Intl.DateTimeFormat(language, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

/// Jour seul, utilisé comme intertitre de la timeline.
///
/// « Aujourd'hui » / « Hier » pour les deux derniers jours : sur une liste de modifications
/// récentes, c'est le repère que l'on cherche en premier.
export function formatHistoryDay(
  value: string,
  language: string,
  todayLabel?: string,
  yesterdayLabel?: string,
): string {
  const date = parsePocketBaseDate(value);
  if (!date) return value;

  if (todayLabel || yesterdayLabel) {
    const startOfDay = (d: Date) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const dayDiff = Math.round(
      (startOfDay(new Date()) - startOfDay(date)) / 86_400_000,
    );

    if (dayDiff === 0 && todayLabel) return todayLabel;
    if (dayDiff === 1 && yesterdayLabel) return yesterdayLabel;
  }

  return new Intl.DateTimeFormat(language, { dateStyle: "full" }).format(date);
}

/// Heure seule, ex. « 14:22 ».
export function formatHistoryTime(value: string, language: string): string {
  const date = parsePocketBaseDate(value);
  if (!date) return value;

  return new Intl.DateTimeFormat(language, { timeStyle: "short" }).format(date);
}
